import { Box, Typography } from '@mui/material'
import type { TPublisherSong } from '@modules/types'
import {
  sectionTitleSx,
  flexWrapContainerSx,
  songCardSx,
  songTitleSx,
  songFieldSx,
} from '../styles'

interface SongsSectionProps {
  songs: TPublisherSong[]
}

export const SongsSection = ({ songs }: SongsSectionProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Songs ({songs.length})</Typography>
      <Box sx={flexWrapContainerSx}>
        {songs.map((song, index) => (
          <Box key={song.id || index} sx={songCardSx}>
            <Typography sx={songTitleSx}>{song.title || `Song ${index + 1}`}</Typography>
            <Box>
              {song.writers && (
                <Typography sx={songFieldSx}>
                  <strong>Writer:</strong> {song.writers}
                </Typography>
              )}
              {song.additionalComments && (
                <Typography sx={songFieldSx}>
                  <strong>Comments:</strong> {song.additionalComments}
                </Typography>
              )}
              {song.publisherFee && (
                <Typography sx={songFieldSx}>
                  <strong>Publisher Fee:</strong> ${song.publisherFee}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
